import React from 'react'
import { createApp } from '@moonpig/web-core-app'

import {
  RemindersNotification,
  IncentivisedRemindersModal,
} from '@moonpig/web-shared-reminders'
import { ConciergeChatModal } from '@moonpig/web-shared-concierge-chat'

export default createApp({
  notifications: [<RemindersNotification key="reminders" />],
  inject: (
    <>
      <IncentivisedRemindersModal />
      <ConciergeChatModal />
    </>
  ),
})
